import { render, staticRenderFns } from "./TemplateBuilder.vue?vue&type=template&id=33ce43bf"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./TemplateBuilder.vue?vue&type=style&index=0&id=33ce43bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports